module.exports = {"username":"demo.kanwil","id":"59","group":"beacukai","status":"enabled","detil":{"nama":"Demo Kanwil","nip":"222222222222222222","pangkat":"Penata Muda - III/a","kode_eselon2":"070000","eselon2":"Kanwil DJBC Jawa Timur I","kode_eselon3":null,"eselon3":null,"kantor":"Kanwil DJBC Jawa Timur I","kantor_id":"070000","kantor_level":"eselon2"},"roleInfo":{"siroleg":[{"role":"siroleg.bc.analis","role_name":"Analis Beacukai","name":"siroleg","domains":"siroleg.beacukai.go.id","description":"Siroleg","icon":null}]}}


//////////////////
// WEBPACK FOOTER
// ./src/router/fake_tokens/token_kanwil.json
// module id = 1sHb
// module chunks = 10